import styled from "styled-components";

export const H1 = styled.h1`
  font-family: "Playfair Display", serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-size: 2.13em;
  font-style: normal;
  margin: 0;
  color: ${({ theme }) => theme.text.default};

  @media (max-width: 340px) {
    font-size: 1.7em;
  }
`;

export const H2 = styled.h2`
  font-family: "Playfair Display", serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-size: 1.5em;
  font-style: normal;
  margin: 0;
  color: ${({ theme }) => theme.text.default};

  @media (max-width: 340px) {
    font-size: 1.2em;
  }
`;

export const H3 = styled.h3`
  font-family: "Playfair Display", serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-size: 0.88em;
  font-style: normal;
  margin: 0;
  color: ${({ theme }) => theme.text.default};

  @media (max-width: 340px) {
    font-size: 0.7em;
  }
`;

export const Title1 = styled.h1`
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
  font-size: 2.13em;
  font-variation-settings: "slnt" 0;
  margin: 0;
  color: ${({ theme }) => theme.text.default};

  @media (max-width: 340px) {
    font-size: 1.7em;
  }
`;

export const Title2 = styled.h2`
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
  font-size: 1.5em;
  font-variation-settings: "slnt" 0;
  margin: 0;
  color: ${({ theme }) => theme.text.default};

  @media (max-width: 340px) {
    font-size: 1.2em;
  }
`;

export const Title3 = styled.h2`
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
  font-size: 1.13em;
  font-variation-settings: "slnt" 0;
  margin: 0;
  color: ${({ theme }) => theme.text.default};

  @media (max-width: 340px) {
    font-size: 0.9em;
  }
`;

export const Title4 = styled.h2`
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 1em;
  font-variation-settings: "slnt" 0;
  margin: 0;
  color: ${({ theme }) => theme.text.default};

  @media (max-width: 340px) {
    font-size: 0.8em;
  }
`;

export const Body = styled.p`
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 0.88em;
  line-height: 1.56em;
  font-variation-settings: "slnt" 0;
  margin: 0;
  white-space: pre-line;
  color: ${({ theme }) => theme.text.default};

  @media (max-width: 340px) {
    font-size: 0.7em;
  }
`;

export const BodySmall = styled.p`
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 0.75em;
  line-height: 1.56em;
  font-variation-settings: "slnt" 0;
  margin: 0;
  white-space: pre-line;
  color: ${({ theme }) => theme.text.default};

  @media (max-width: 340px) {
    font-size: 0.7em;
  }
`;

export const Caption = styled.p`
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 0.69em;
  line-height: 1.56em;
  font-variation-settings: "slnt" 0;
  margin: 0;
  color: ${({ theme }) => theme.text.default};

  @media (max-width: 340px) {
    font-size: 0.55em;
  }
`;
